var map = {
	"./account-ico-mail.svg": 815,
	"./account-ico-pass.svg": 816,
	"./account-ico-phone.svg": 817,
	"./bank-transfer.svg": 818,
	"./betnearn-ico.svg": 819,
	"./birthday-bonus-ico.svg": 820,
	"./birthday.webp": 1899,
	"./bonus-code-ico.svg": 821,
	"./bonus-ico.svg": 822,
	"./bonus-received-ico.svg": 823,
	"./bonus.webp": 1900,
	"./business-account-upgrade-ico.svg": 824,
	"./check-in-daily-ico.svg": 825,
	"./checked.svg": 826,
	"./cloud-pointer.svg": 827,
	"./crypto.svg": 828,
	"./daily-bonus-ico.svg": 829,
	"./daily-limit.webp": 1901,
	"./deposit-delay-bonus-ico.svg": 830,
	"./e-wallet.svg": 831,
	"./earn-coin-ico.svg": 832,
	"./earn-x33-coin-ico.svg": 833,
	"./email.svg": 834,
	"./facebook.svg": 835,
	"./feedback.svg": 836,
	"./first-bet-ico.svg": 837,
	"./games-rebate-ico.svg": 838,
	"./info.svg": 839,
	"./instagram.svg": 840,
	"./instant-rebate.svg": 841,
	"./live-casino-rebate-ico.svg": 842,
	"./lucky-spin-ico.svg": 843,
	"./messenger.svg": 844,
	"./mobile-app-deposit-ico.svg": 845,
	"./monthly-cash.webp": 1902,
	"./msg-activity.svg": 846,
	"./msg-ann.svg": 847,
	"./msg-notice.svg": 848,
	"./new-icon.svg": 849,
	"./people-ico.svg": 850,
	"./quick-pay.svg": 851,
	"./r77-coin.svg": 852,
	"./rescue-bonus-ico.svg": 853,
	"./rescue-lc-ico.svg": 854,
	"./rescue-slots-ico.svg": 855,
	"./return.svg": 856,
	"./sc-bc-active-ico.svg": 857,
	"./sc-bc-ico.svg": 858,
	"./sc-bi-active-ico.svg": 859,
	"./sc-bi-ico.svg": 860,
	"./sc-mail-active-ico.svg": 861,
	"./sc-mail-ico.svg": 862,
	"./sc-mp-active-ico.svg": 863,
	"./sc-mp-ico.svg": 864,
	"./sc-pin-active-ico.svg": 865,
	"./sc-pin-ico.svg": 866,
	"./slots-rebate-ico.svg": 867,
	"./sports-rebate-ico.svg": 868,
	"./telegram.svg": 869,
	"./twitter.svg": 870,
	"./vip-up-level-ico.svg": 871,
	"./vip-weekly-bonus.svg": 872,
	"./wallet-ico.svg": 873,
	"./weekly-tournament-ico.svg": 874,
	"./welcome-bonus-ico.svg": 875,
	"./whatsapp.svg": 876,
	"./withdrawal-delay-bonus-ico.svg": 877,
	"./withdrawal.webp": 1903,
	"./x33-coin.svg": 878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481;